
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 4">
  <path
    d="M3.61403 0.541457L6.4738 3.34608C6.53966 3.41071 6.4738 3.5 6.36039 3.5L0.639614 3.5C0.526199 3.5 0.460345 3.41071 0.526199 3.34608L3.38719 0.541457C3.44207 0.486181 3.55793 0.486181 3.61403 0.541457Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'CaretTop',
    }) as DefineComponent
    </script>
    